module.exports = {
  methods: {
    hello: function () {
      console.log('hello from mixin!')
    },
    quotationMargin: (price, cost) => price/(cost -1),
    formatFloat: (amount, places) => parseFloat(amount).toFixed(places),
    grossMargin (data, type) {
      switch(type) {
        case 1:
          return data.price ? (((parseFloat(data.price) / parseFloat(data.cost)) - 1) * 100).toFixed(2) + '%' : null
        break
        case 2:
          const manufacturing_price = parseFloat(data.cost_setup) + parseFloat(data.cost_etest_tooling)
          const sell_price = parseFloat(data.price_etest_tooling) + parseFloat(data.price_setup)
          return sell_price ? (((sell_price / manufacturing_price - 1)) * 100).toFixed(2) + '%' : null
        break
      }
    } 
  }
}


// WEBPACK FOOTER //
// ./src/mixins/amount-functions.js